import { render, staticRenderFns } from "./DialogGenerarSaleOrder.vue?vue&type=template&id=0970af57&"
import script from "./DialogGenerarSaleOrder.vue?vue&type=script&lang=js&"
export * from "./DialogGenerarSaleOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports